export enum SubPlanEnum {
  "Pay As You Go" = String(process.env.REACT_APP_ENV) === "production" ? 0 : 3,
  "Professional" = String(process.env.REACT_APP_ENV) === "production" ? 1 : 4,
  "Advanced" = String(process.env.REACT_APP_ENV) === "production" ? 2 : 5,
  "Corporate" = String(process.env.REACT_APP_ENV) === "production" ? 6 : 7,
}
